<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
    <!-- <transition :name="transitionName">
    <div class="sideAd" v-show="isRightAll">
      <a @click="sideClick"
       v-show="isRightNav"
        >
        <img
          :src="
            isLogin ? '/static/img/getRedpack.gif' : '/static/img/lihe.gif'
          "
          alt=""
      />
      </a>

      <div class="rightBoxNav" v-show="isRightNav">
        <ul>
          <li @click="clkIM()">
            <p class="fa iconSet">&#xe71a;</p>
            <p>在线客服</p>
          </li>
          <li>
            <p class="fa iconSet">&#xe6ff;</p>
            <p>微信咨询</p>
            <div
              class="decBox"
              style="right: 70px; width: 120px; height: 120px; margin-top: -1px"
            >
              <img
                src="/static/img/QRcode2.jpg"
                style="width: 90px; height: 90px"
              />
            </div>
          </li>
          <li>
            <p class="fa iconSet">&#xe72c;</p>
            <p>电话咨询</p>
            <div
              class="decBox"
              style="
                right: 70px;
                width: 250px;
                height: 50px;
                line-height: 50px;
                margin-top: -1px;
              "
            >
              <i class="fa marR5">&#xe651;</i>24小时服务热线：400 926 8156
            </div>
          </li>
          <li @click="clkBtn(1)">
            <p class="fa iconSet">&#xe716;</p>
            <p>空运询盘</p>
          </li>
          <li @click="clkBtn(2)">
            <p class="fa iconSet">&#xe632;</p>
            <p>空运门到门</p>
          </li>
          <li @click="clkBtn(3)">
            <p class="fa iconSet">&#xe738;</p>
            <p>热门产品</p>
          </li>
          <li @click="clkBtn(4)">
            <p class="fa iconSet">&#xe8a4;</p>
            <p>帮助中心</p>
          </li>
        </ul>
        <div class="colseSet" @click="clkRightNav">
          <i class="fa font20 colGray6">&#xe70d;</i>
        </div>
      </div>
    </div>
    </transition>
    <div class="tipsSub" v-show="!isRightAll" @click="clkRightNav">
        <i class="fa">&#xe616;</i>
    </div> -->
    <!-- <div class="rightMenu">
        <div class="item message-box" @mouseenter="mouseEnterMenu(0)" @mouseleave="mouseLeaveMenu">
           <span v-if="rightMenu == 0" class="span-title-2" @click="clkIM()">在线客服</span>
          <div v-else-if="rightMenu == -1 || rightMenu != 0" class="first-icon" >
            <svg-icon name="kefu2" size="27"></svg-icon>
          </div>
        </div>
        <div class="item weixin-show" @mouseenter="mouseEnterMenu(1)" @mouseleave="mouseLeaveMenu">
            <span v-if="rightMenu == 1" class="span-title-2">微信咨询</span>
            <div v-else-if="rightMenu == -1 || rightMenu != 1" class="first-icon" >
              <svg-icon name="weixin1" size="27"></svg-icon>
            </div>
            <div class="weixin-box">
               <img alt="微信" src="/static/img/QRcode2.jpg" width="100" height="100" />
            </div>
        </div>
        <div class="item" @click="toTop()" @mouseenter="mouseEnterMenu(2)" @mouseleave="mouseLeaveMenu">
          <span v-if="rightMenu == 2" class="span-title">置顶</span>
          <div v-else-if="rightMenu == -1 || rightMenu != 2" class="first-icon" >
            <svg-icon name="zhiding" size="27"></svg-icon>
          </div>
        </div>
    </div> -->
    <transition>
      <div id="rightMenu" class="rightMenu">
        
        <div class="el-fade-in-linear">
          <Guide v-if="isIndexAndCheckPage" ref='guideRight' @input="showGuid"></Guide>
          <!-- <div class="item weixin-show flex_col_center2">!isIndexAndCheckPage
            <div class="flex_col_center2">
            
            </div>
          </div> -->
          <div
            class="item weixin-show flex_col_center2"
            v-if="SalesQrCode || KFQrCode"
          >
            <div
              class="flex_col_center2"
              @click="
                () => {
                  connectDialogValue = true;
                }
              "
            >
              <!-- <iconComm
                    size="24"
                    iconName="icon-weixin"
                    iconColor="#0046B9"
                    :isStyle="false"
                  >
                  </iconComm> -->
              <div class="connect-icon"></div>

              <div class="top-box">
                <img
                  alt="top"
                  src="../static/newStatic/img/leftFixedIcon/connectTip.png"
                  width="80"
                  height="28"
                />
              </div>
            </div>
          </div>
          
          
          <div class="item weixin-show flex_col_center2">
            <div class="flex_col_center2">
              <!-- <iconComm
                    size="24"
                    iconName="icon-weixin"
                    iconColor="#0046B9"
                    :isStyle="false"
                  >
                  </iconComm> -->
              <div class="weixin-icon"></div>

              <div class="weixin-box">
                <img
                  alt="公众号"
                  src="../static/newStatic/img/asideMenu/公众号二维码@2x.png"
                  width="314"
                  height="136"
                />
              </div>
            </div>
          </div>

          <div class="item weixin-show flex_col_center2 borShow">
            <div class="flex_col_center2">
              <!-- <iconComm
                    size="24"
                    iconName="icon-moren"
                    iconColor="#0046B9"
                    :isStyle="false"
                  >
                  </iconComm> -->
              <div class="program-icon"></div>
              <div class="weixin-box">
                <img
                  alt="小程序"
                  src="../static/newStatic/img/asideMenu/小程序二维码@2x.png"
                  width="314"
                  height="136"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- <div
          :class="[
            'item',
            'top-box',
            topClass ? 'topClassShow' : 'topClassHide',
          ]"
          @click="toTop()"
          @mouseover="goTopIcon = 'fanhuidingbu-gaoliang'"
          @mouseout="goTopIcon = 'fanhuidingbu'"
        >
          <div class="gotopContent">
            <svg-icon size="24" :name="goTopIcon" class="goTopIcon"> </svg-icon>
            <div class="maR_t8">返回顶部</div>
          </div>
        </div> -->

        <div
          class="flex_col_center2 el-fade-in-linear weixin-show borShow"
          :class="[
            'item item1',
            'top-box',
            topClass ? 'topClassShow' : 'topClassHide',
          ]"
          @click="toTop()"
        >
          <div class="flex_col_center2">
            <!-- <iconComm
                  size="24"
                  iconName="icon-fanhuidingbu"
                  iconColor="#0046B9"
                  :isStyle="false"
                >
                </iconComm> -->
            <div class="top-icon"></div>
            <!-- <div class="maR_t8">返回顶部</div> -->
            <div class="top-box">
              <img
                alt="top"
                src="../static/newStatic/img/leftFixedIcon/top.png"
                width="80"
                height="28"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- <div class="dialogBoxWx">
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :show-close="false"
        custom-class="borRad10"
        width="460px"
      >
        <div class="frameContent" style="text-align: center">
          <div><img src="../static/img/wxTips2.jpg" /></div>
        </div>
      </el-dialog>
    </div> -->
    <connect-dialog
      v-if="SalesQrCode || KFQrCode"
      :show="connectDialogValue"
      @close="
        (val) => {
          connectDialogValue = false;
        }
      "
    ></connect-dialog>
    <VersionUpdateDialog
      v-if="versionUpdateDialog"
      v-model="versionUpdateDialog"
    ></VersionUpdateDialog>
     <SelectGuide 
     ref="SelectGuide"
      :type='"select"'  
      :active="SelectGuideActive"
      :steps="guideSteps"
      @done="done"
      @open="open"
      ></SelectGuide>
     <SelectGuide 
     ref="moduleGuide"
      :type='"module"'  
      :active="moduleGuideActive"
      :steps="moduleGuideSteps"
      @done="done()"
      @open="open()"
      ></SelectGuide>
      <!-- <div id='check-2' class="img-tip" v-if="isImg">
      </div> -->
  </div>
</template>
<script type="text/ecmascript-6">
import SelectGuide from './components/backstageManagement/guide/guide.vue'
import Vue from "vue";
import jq from "jquery";
import bus from "@/ask/eventBus";
import { getCookie, setCookie } from "@/ask/cookiejs";
import { fetch } from "@/ask/axios";
import ByCountDowm from "@/common/components/ByCountDowm.vue";
import VersionUpdateDialog from "./components/VersionUpdateDialog.vue";
import ConnectDialog from "./components/ConnectDialog.vue";
import { getAccountInfo } from '@/util/util'
import Guide from './components/backstageManagement/guide/index.vue'

export default {
  components: {
    ByCountDowm,
    VersionUpdateDialog,
    ConnectDialog,
    Guide,
    SelectGuide
  },
  data() {
    return {
      connectDialogValue: false,
      isRouterAlive: true,
      dialogVisible: false,
      isLogin: false,

      isRightNav: true,
      countOut: 0,
      isRightAll: true,
      transitionName: "slide-left",
      rightMenu: -1,
      topClass: "",
      versionUpdateDialog: false,
      intervalTime: null,
      goTopIcon: "fanhuidingbu",
      SalesQrCode: '',
      KFQrCode: '',
      SelectGuideActive:false,
      guideSteps: [
        {
          selector: '#check-1',
          title: '产品服务类型',
          description: '在这里鼠标点击选择适合你的产品<b>服务类型</b><span style="color: #777777;">（此教程仅示范国际快递查价）</span>',
          position: 'bottom',
          top:0
        },
        {
          selector: '#check-2',
          title: '信息填写',
          description: '在弹窗内完善<b>查价信息</b>。',
          position: 'left',
          offsetX: -8, // 向右偏移50px
          offsetY: 0, // 向上偏移20px
          arrowOffset: 50, // 箭头向右偏移30px
          alignment: 'left', // 顶部居左
          transitionDuration: 300, // 弹框过渡动画时长（毫秒）
        },
        {
          selector: '#check-3',
          title: '点击确定',
          description: '完善完毕查价信息后，点击<b>确定</b>即可查价。',
          position: 'top',
          top:0
        },
      ],
      moduleGuideActive: false,
      moduleGuideSteps:[],
      moduleGuideSteps1: [
        {
          selector: '#module-1',
          title: '基础信息',
          description: '这里可以查看此账号的<b>基础信息和认证状态</b>。<br/>右侧可以查看你的<b>专属销售和客服</b>联系方式。鼠标悬停对应区域可以直接扫码添加。',
          position: 'bottom',
          top:0
        },
        // {
        //   selector: '#module-2',
        //   title: '专属服务联系方式',
        //   description: '这里可以查看你的<b>专属销售和客服</b>联系方式。鼠标悬停对应区域可以直接扫码添加。',
        //   position: 'bottom',
        //   top:0
        // },
        {
          selector: '#module-3',
          title: '自定义工作台',
          description: '点击<b>自定义工作台</b>，可以选择板块任意拖动，根据需要自由布置你的专属工作台。',
          position: 'bottom',
          offsetX: 0, // 向右偏移50px
          offsetY: 0, // 向上偏移20px
          arrowOffset: 20, // 箭头向右偏移30px
          alignment: 'right' // 顶部居左
        },
      ],
      isImg:false,
       guideItem: {
        'CheckPrice':{
            selector: '#CheckPrice',
            title: '产品服务',
            description: '在这里可以选择适合你的<b>产品服务类型</b>，查价下单更快捷。',
            position: 'bottom',
            top:0
        },
        'imagePromotion':{
          selector: '#imagePromotion',
          title: '平台活动',
          description: '这里会不定期更新<b>平台活动</b>。',
          position: 'bottom',
          top:0
        },
        'accountBalance':{
          selector: '#accountBalance',
          title: '账户余额',
          description: '在这里可查看账户各币种的余额，更快触达充值和优惠券。',
          position: 'bottom',
          top:0
        },
        'myAccount':{
          selector: '#myAccount',
          title: '我的账单',
          description: '在这里可查看<b>待支付</b>的账单金额，点击<b>全部账单</b>可跳转账单查询页面。',
          position: 'bottom',
          top:0
        },
        'Order':{
          selector: '#Order',
          title: '进行中的订单',
          description: '在这里可快捷查看、操作进行中的订单。点击<b>查看全部</b>可跳转对应订单列表。',
          position: 'bottom',
          top:0
        },
        'AKeyOrder':{
          selector: '#AKeyOrder',
          title: '我的走货渠道',
          description: '在这里可以一键下单<b>历史走过货的渠道</b>。',
          position: 'bottom',
          top:0
        },
        'preference':{
          selector: '#preference',
          title: '特惠秒杀',
          description: '这里会不定时更新平台的<b>特惠</b>渠道活动。',
          position: 'bottom',
          top:0
        },
        'backlogProblem':{
          selector: '#backlogProblem',
          title: '待办问题',
          description: '在这里查看待处理的问题件，及时处理、回复，避免遗漏。',
          position: 'bottom',
          top:0
        },
        'headLine':{
          selector: '#headLine',
          title: '百运头条',
          description: '这里可查看平台的最新<b>资讯</b>，及时接收不错过。',
          position: 'bottom',
          top:0
        },
        'Map':{
          selector: '#Map',
          title: '地图看板',
          description: '联动<b>进行中的订单</b>切换，实现订单状态数据可视化。',
          position: 'bottom',
          top:0
        },
        'integral':{
            selector: '#integral',//积分
            title: '积分签到',
            description: '在这里可以快捷签到，签到的积分可以兑换很多好礼哦～',
            position: 'bottom',
        }
        },
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  watch: {
    isRightAll: function (val) {
      if (val) {
        this.transitionName = "slide-left";
      } else {
        this.transitionName = "slide-right";
      }
    },
  },
  computed: {
    // 计算属性
    // 判断是否是查价结果页
    isIndexAndCheckPage() {
      console.log("======地址====",this.$route.fullPath,this.$route);
      return [
        'customerCenter',
        "exp/expEdit",
        "air/airOrderEdit",
        "fba/order/orderEdit",
        "sea/seaOrderEdit",
        "seaFull/seaFullOrderEditNew",
        "seaFull/seaFullOrderEdit"
      ].some((item) => this.$route.fullPath.indexOf(item) !== -1);
    },
  },
  created() {
    this.isWxChat();

    //记录是右侧广告导航是打开还是关闭状态
    let navRecord = getCookie("RNavRecord");
    if (navRecord) {
      this.isRightNav = JSON.parse(navRecord);
    }

  },
  async mounted() {
    window.addEventListener("scroll", this.menu);
    // window.addEventListener("click", this.handlerVersionUpdate);
    this.chatWindow(); //引入IM
    // 获取用户信息，更新session
    let customerInfo = await getAccountInfo(this, 1);
    console.log(customerInfo, "customerInfo");
    if (customerInfo) {
      this.SalesQrCode = customerInfo.SalesQrCode;
      this.KFQrCode = customerInfo.KFQrCode;
    }
    let SalesInfos = JSON.parse(sessionStorage.getItem("loginMessage"));
    let CustomerOwnerType = SalesInfos.CustomerOwnerType;
    if(CustomerOwnerType == 0){
      let data = {
          selector: '#integral',//积分
          title: '积分签到',
          description: '在这里可以快捷签到，签到的积分可以兑换很多好礼哦～',
          position: 'top',
      }
      this.moduleGuideSteps.push(data);
    }
    this.$nextTick(() => {
      const token = getCookie("JWT-TOKEN");
      if (token) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
        setTimeout(() => {
        if(this.$route.query.isGuide == '1'){
          this.showGuid('select')
        }
        if(this.$route.query.isGuide == '2'){
          this.showGuid('module')
        }

        }, 2000);
    })
    console.log("===路径====",window.location.pathname,this.$route.path);
    //接收工作台模块传过来的模块信息
    bus.$on("LayoutReady", (val, isName) => {
      //console.log("======工作台===",val);
      
      const newArray = val.map((item) => {
        return this.guideItem[item.id]
      })
      let newGuideSteps = this.moduleGuideSteps1.concat(newArray)
      this.moduleGuideSteps = newGuideSteps
      //console.log("====新数组===",this.moduleGuideSteps1,newArray);
    });

    
    this.showRightNav(0);

    this.saveVersion();

    // let fullPath = window.location.pathname;
    // if (
    //   ([
    //     "customerCenter",
    //     "exp",
    //     "air",
    //     "fba",
    //     "special",
    //     "PickupList",
    //     'PickupDetails',
    //     'problem',
    //     'dhl',
    //     'checkList'
    //   ].some((item) => fullPath.indexOf(item) != -1))
    // ) {
    //   let that = this;
    //   this.intervalTime = setInterval(() => {
    //     that.handlerLocalVersionUpdate();
    //   }, 3000);
    // }
  },
  methods: {
    open(val){  
      if(val=='up'){
        this.isImg = false;
        bus.$emit("showGuide",2);
        
      }
      if(val=='next' ){
        this.isImg = true;
        bus.$emit("showGuide",1);
        
      }
    },
    done(val){
      this.SelectGuideActive = false;
      this.moduleGuideActive = false;
      this.isImg = false;
      //this.$refs.guideRight.isShow = true;
      console.log("=====done===",val);
      if(val=='select'){
        bus.$emit("showGuide",2);
      }
      
    },
    showGuid(val){
      if(val == 'module'){
        this.moduleGuideActive = true
      }
      if(val == 'select'){
        this.SelectGuideActive = true
      }
    },
    // 检查本地版本号是否一致
    handlerLocalVersionUpdate() {
      // 当弹框已经显示了之后就不再去判断
      if (this.versionUpdateDialog) {
        return false;
      }
      let localSystemVersion = localStorage.getItem("SYSTEM_VERSION");
      // let systemVersion = require("#/js/version.json");
      if (localSystemVersion) {

        if (localSystemVersion != SYSTEM_VERSION) {
          window.location.reload();
        }
      } else {
      }
      // console.log(333333333);
    },
    // 存入版本号
    saveVersion() {
      // 版本号更新
      let localSystemVersion = localStorage.getItem("SYSTEM_VERSION");
      let systemVersion = require("#/js/version.json");
      console.log(systemVersion, 'systemVersion');
      // 判断是否存在本地版本号
      if (localSystemVersion) {
        if (localSystemVersion != systemVersion.systemVersion) {
          // 存入本地版本号
          localStorage.setItem("SYSTEM_VERSION", systemVersion.systemVersion);
        }
      } else {
        localStorage.setItem("SYSTEM_VERSION", systemVersion.systemVersion);
      }

      systemVersion = null;
    },
    // 判断版本号是否一致
    async handlerVersionUpdate() {
      // 当弹框已经显示了之后就不再去判断
      if (this.versionUpdateDialog) {
        return false;
      }
      let newDateTime = new Date(); // 当前时间
      let systemVersion = await fetch('/static/js/version.json?' + `t=${newDateTime.getTime()}`); // 请求 static 下的目录文件时，请看 README.md 详解
      // console.log(systemVersion)
      let localSystemVersion = localStorage.getItem("SYSTEM_VERSION");
      // 判断是否存在本地版本号
      if (localSystemVersion) {
        // 本地版本号和打包部署的版本号不一致，存入本地版本号，并且弹出版本更新弹框
        if (localSystemVersion != systemVersion.systemVersion) {
          // 弹出版本更新弹框
          this.versionUpdateDialog = true;
          // 存入本地版本号
          // localStorage.setItem("SYSTEM_VERSION", systemVersion.systemVersion)
        }
      } else {
        // 没有本地版本号的情况下，存入本地版本号，并且弹出版本更新弹框
        // 弹出版本更新弹框
        this.versionUpdateDialog = true;
        // 存入本地版本号
        // localStorage.setItem("SYSTEM_VERSION", systemVersion.systemVersion)
      }
      //   // 清除版本号文件
      systemVersion = null;
    },
    // 移入此元素触发， 子元素不触发
    mouseEnterMenu(type) {
      this.rightMenu = type;
    },
    // 移出此元素触发， 子元素不触发
    mouseLeaveMenu() {
      this.rightMenu = -1;
    },
    //监听页面滚动事件
    menu(e) {
      // this.isRightAll = true;
      // this.isRightNav = true;
      // $(".tipsSub").css("display", "none");
      // //this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      // this.showRightNav(0);
      let scrollTop =
        e.target.documentElement.scrollTop || e.target.body.scrollTop;

      if (scrollTop > 100) {
        this.topClass = true;
      } else {
        this.topClass = false;
      }
    },
    toTop() {
      // 回到顶部
      $("html,body").animate({ scrollTop: 0 }, 800);
    },
    //页面加载5秒后右侧栏隐藏
    showRightNav(countOut) {
      this.isRightAll = true;
      if (countOut == 0) {
        setTimeout(() => {
          this.isRightAll = false;
          //$('#rightBoxNav').addClass('fadeOutRight animated');
          $(".tipsSub").css("display", "block");
        }, 5000);
      }
    },
    //判断是否是微信内置浏览器，是的话就提示
    isWxChat() {
      //判断是否是微信内置浏览器
      var ua = window.navigator.userAgent.toLowerCase();
      //console.log(ua);//mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //是微信浏览器
        this.dialogVisible = true;
      }
    },

    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },

    async goActivityPage() {
      //  神策
      await this.clkBanner(
        "",
        "首页横幅广告位",
        "新人活动",
        "1",
        window.location.href,
        "1"
      );
      // debugger
      let newpage = this.$router.resolve({
        name: "ActivityGift",
      });
      // window.open(newpage.href, "_blank");
      this.browserHref(newpage.href, 2);
    },
    sideClick() {
      // this.registerResult('客户注册888',false,'2') //神策

      const token = getCookie("JWT-TOKEN");
      // let w = window.open();

      if (token) {
        // w.location.href = "/MyInfo/myInvite";
        this.browserHref("/MyInfo/myInvite", 2);
        this.clkBanner(
          "",
          "浮层栏目广告位",
          "新人活动",
          "1",
          window.location.href,
          "1"
        );
      } else {
        // w.location.href = "/activityGift";
        this.browserHref("/activityGift", 2);
        //新人活动
        this.clkBanner(
          "",
          "浮层栏目广告位",
          "邀请活动",
          "2",
          window.location.href,
          "2"
        );
      }
    },

    //点击右侧导航栏跳转
    clkIM() {
      //this.SDInstantMessaging()
      $(".CHATS-PANEL-HOLDER").show();
    },
    //IM
    chatWindow() {
      var imtoken = $.cookie("IM-TOKEN");
      var script = document.createElement("script");
      script.setAttribute("type", "text/javascript");
      script.setAttribute("id", "imimport");
      script.setAttribute(
        "src",
        Vue.prototype.$apiIMCh +
        "Content/ChatIM/js/imimport.js?verson=" +
        Math.random() +
        "&entId=1&token=" +
        imtoken
      );
      document.getElementsByTagName("head")[0].appendChild(script);
    },

    clkBtn(code) {
      // let w = window.open();
      // switch (code) {
      //   case 1:
      //     w.location.href = this.$nuxtPage + "frontInquiry";
      //     break;
      //   case 2:
      //     w.location.href = this.$nuxtPage + "frontAirCheck";
      //     break;
      //   case 3:
      //     w.location.href = this.$nuxtPage + "landPageHome";
      //     break;
      //   case 4:
      //     w.location.href = this.$nuxtPage + "helpCenter.html";
      //     break;
      // }
      let urlList = ['/', (this.$nuxtPage + "frontInquiry"), (this.$nuxtPage + "frontAirCheck"), (this.$nuxtPage + "landPageHome"), (this.$nuxtPage + "helpCenter.html")];

      this.browserHref(urlList[code], 2);
    },

    //点击右侧导航操作
    clkRightNav() {
      $(".tipsSub").css("display", "block");
      //this.isRightNav = !this.isRightNav;
      this.isRightAll = !this.isRightAll;
      //存点击的最后一次操作，当天在进入的时候，记住操作记录，第二天清空操作回复默认
      setCookie("RNavRecord", this.isRightNav, 1, "/");
    },
  },
  beforeDestroy() {
    // 实例销毁之前对点击事件进行解绑
    window.removeEventListener("scroll", this.menu);
    // window.removeEventListener("click", this.handlerVersionUpdate);
    // let fullPath = window.location.pathname;
    // if (
    //   ([
    //     "customerCenter",
    //     "exp",
    //     "air",
    //     "fba",
    //     "special",
    //     "PickupList",
    //     'PickupDetails',
    //     'problem',
    //     'dhl',
    //     'checkList'
    //   ].some((item) => fullPath.indexOf(item) != -1))
    // ) {
    //   clearInterval(this.intervalTime);
    //   this.intervalTime = null;
    // }
  },
};
</script>
<style lang="scss" type="text/css" rel="stylesheet" scoped="scoped">
#app {
  // min-width: 1200px;
  height: 100%;
}

@mixin fixed {
  position: fixed;
  z-index: 999;
}

.flex_col_center2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.slide-left-enter,
.slide-right-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.slide-left-leave-to,
.slide-right-enter {
  opacity: 0;
  transform: translateX(-100%);
  //position: absolute;
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  //transition: 1s;
  //position: absolute;
  top: 0;
  transition: all 0.75s ease;
}

.sideAd {
  position: fixed;
  z-index: 999;
  right: 0px;
  top: 75px;
  img {
    width: 80px;
    // height: 95px;
    margin-bottom: 5px;
  }
}
.rightBoxNav {
  position: fixed;
  z-index: 10;
  right: 0px;
  //top: 180px;
  background: white;
  width: 70px;
  height: 355px;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px 0px 0px 5px;
  ul li {
    border-bottom: 1px solid #ebebeb;
    padding: 5px 0;
    text-align: center;
    cursor: pointer;
    position: relative;
  }
  ul li:last-child {
    border: 0px;
  }
  ul li .iconSet {
    font-size: 18px;
    color: #999;
  }
  ul li p {
    line-height: 20px;
  }
  ul li:hover {
    background: #0c5ee4;
    color: white !important;
    transition: background 0.5s;
    -webkit-transition: background 0.5s;
  }

  ul li:first-child:hover {
    border-radius: 5px 0px 0px 0;
  }
  ul li:last-child:hover {
    border-radius: 0px 0px 0px 5px;
  }
  ul li:hover .iconSet {
    color: white !important;
  }

  ul li .decBox {
    position: absolute;
    background: #0c5ee4;
    color: white;
    top: 0;
    border-radius: 10px 0px 0px 10px;
    font-size: 14px;
    display: none;
    border: 1px solid #fff;
    border-right: 0px;

    // box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
  }

  ul li .decBox img {
    margin: auto;
    margin-top: 15px;
  }
  ul li:hover .decBox {
    display: block;
    -webkit-transition: all 0.3s ease-in;
    -moz-transition: all 0.3s ease-in;
    -ms-transition: all 0.3s ease-in;
    transition: all 0.3s ease-in;
    -webkit-transform-origin: 0px 0px;
    -moz-transform-origin: 0px 0px;
    transform-origin: 0px 0px;
    -moz-backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transition: background 0.5s;
  }
  .colseSet {
    padding: 10px 30px;
    cursor: pointer;
  }
}
.tipsSub {
  background: #0c5ee4;
  color: #fff;
  font-size: 20px;
  height: 50px;
  width: 28px;
  border-radius: 100px 0 0 100px;
  cursor: pointer;
  text-align: center;
  position: fixed;
  right: 0px;
  top: 380px;
  border: 1px solid #fff;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
}
.tipsSub i {
  margin-top: 15px;
  transform: rotate(180deg);
  -ms-transform: rotate(180deg); /* IE 9 */
  -moz-transform: rotate(180deg); /* Firefox */
  -webkit-transform: rotate(180deg); /* Safari å’Œ Chrome */
  -o-transform: rotate(180deg); /* Opera */
}

.bottomAd {
  height: 140px;
  width: 100%;
  bottom: 0;

  @include fixed;
  display: flex;
  justify-content: center;
  //background: linear-gradient( to right, rgba(13, 23, 37, 0.7), #0D1725, rgba(13, 23, 37, 0.7));
  background: linear-gradient(
    to right,
    rgba(13, 23, 37, 0.6),
    #0d1725,
    #0d1725,
    #0d1725,
    #0d1725,
    rgba(13, 23, 37, 0.6)
  );
  background: -moz-linear-gradient(
    to right,
    rgba(13, 23, 37, 0.7),
    #0d1725,
    #0d1725,
    #0d1725,
    #0d1725,
    rgba(13, 23, 37, 0.7)
  );
  background: -webkit-gradient(
    to right,
    rgba(13, 23, 37, 0.7),
    #0d1725,
    #0d1725,
    #0d1725,
    #0d1725,
    rgba(13, 23, 37, 0.7)
  );
  background: -webkit-linear-gradient(
    to right,
    rgba(13, 23, 37, 0.7),
    #0d1725,
    #0d1725,
    #0d1725,
    #0d1725,
    rgba(13, 23, 37, 0.7)
  );
  background: -o-linear-gradient(
    to right,
    rgba(13, 23, 37, 0.5),
    #0d1725,
    #0d1725,
    #0d1725,
    #0d1725,
    rgba(13, 23, 37, 0.7)
  );
  background: -ms-linear-gradient(
    to right,
    rgba(13, 23, 37, 0.5),
    #0d1725,
    #0d1725,
    #0d1725,
    #0d1725,
    rgba(13, 23, 37, 0.5)
  );

  a {
    height: 100%;
    width: 1201px;
    position: relative;
    opacity: 1 !important;
    img {
      /* position: absolute; */
      /* left: 50%; */
      margin: 0 auto;
      /* margin-bottom: 72px; */
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -19px;
      width: auto;
      height: auto;
    }
  }

  .close-ad {
    position: absolute;
    right: 56px;
    top: 18px;
    color: #ffffff;
    font-size: 18px;
    opacity: 0.5;
    cursor: pointer;
  }
}

.rightMenu {
  // display: flex;
  // flex-direction: column;
  position: fixed;
  z-index: 2001;
  right: 8px;
  // bottom: 24px;
  bottom: 96px;
  cursor: pointer;
}

.rightMenu {
  .item {
    width: 36px;
    height: 36px;
    background: rgba(255, 255, 255, 0.88);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    border: 1px solid #f7f8fa;
    position: relative;
    margin-top: 8px;
    box-sizing: border-box;
    // margin-top: 8px;
    &:hover {
      border: 1px solid rgba(0, 70, 185, 0.32);
      box-sizing: border-box;
      transition: all 0.5s;
      .gotopContent .maR_t8 {
        color: #0046b9;
        cursor: pointer;
      }
    }
    .gotopContent {
      width: 48px;
      height: 48px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: auto;
      .goTopIcon {
        position: absolute;
        top: 8px;
      }
    }

    .maR_t8 {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      letter-spacing: 1px;

      text-align: center;
      display: block;
      cursor: pointer;
      position: absolute;
      bottom: 8px;
    }
  }

  .item1 {
    height: 36px;
  }

  .span-title {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0c5ee4;
    line-height: 56px;
    letter-spacing: 1px;

    text-align: center;
    display: block;
    cursor: pointer;
  }

  .span-title-2 {
    display: block;
    width: 30px;
    height: 30px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0c5ee4;
    line-height: 15px;
    letter-spacing: 1px;

    padding: 13px 11px 13px 15px;
    cursor: pointer;
  }

  .first-icon {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;

    // .red-circle {
    //   width: 8px;
    //   height: 8px;
    //   background: #cf3737;
    //   border-radius: 50%;

    //   position: absolute;
    //   top: 8px;
    //   right: 8px;
    // }
  }

  .message-info {
    display: none;
    position: absolute;
    right: 61px;
    top: 5px;

    width: 230px;
    height: 46px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;

    .flex-box {
      display: flex;

      .message-icon {
        padding: 13px 14px;
      }

      .text {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 46px;

        width: 170px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .message-box {
    .icon1 {
      // display: block;
      opacity: 1;
      // @extend .first-icon;
      transition: all 1s;
    }

    .span-title-icon {
      opacity: 0;
      display: none;
      // @extend .span-title-2;
      transition: all 1s;
    }

    .customer-icon {
      width: 24px;
      height: 24px;
      background: url("../static/newStatic/img/leftFixedIcon/ic_overall_customer_default@2x.png")
        no-repeat;
      background-size: 24px 24px;
      transition: all 1s;
    }
  }
  .message-box:hover {
    color: #0046b9;
    cursor: pointer;
    .customer-icon {
      width: 24px;
      height: 24px;
      background: url("../static/newStatic/img/leftFixedIcon/ic_overall_customer_hover@2x.png")
        no-repeat;
      background-size: 24px 24px;
      transition: all 1s;
    }
    .icon1 {
      opacity: 0;
      display: none;
      transition: all 1s;
    }

    .span-title-icon {
      opacity: 1;
      display: block;
      transition: all 1s;
    }
  }

  .weixin-show {
    .icon1 {
      opacity: 1;
      @extend .first-icon;
      transition: all 1s;
    }

    .span-title-icon {
      opacity: 0;
      display: none;
      @extend .span-title-2;
      transition: all 1s;
    }

    .connect-icon {
      width: 24px;
      height: 24px;
      background: url("../static/newStatic/img/leftFixedIcon/ic_overall_connect_default@2x.png")
        no-repeat;
      background-size: 24px 24px;
      transition: all 1s;
    }

    .weixin-icon {
      width: 24px;
      height: 24px;
      background: url("../static/newStatic/img/leftFixedIcon/ic_overall_wechat_default@2x.png")
        no-repeat;
      background-size: 24px 24px;
      transition: all 1s;
    }

    .program-icon {
      width: 24px;
      height: 24px;
      background: url("../static/newStatic/img/leftFixedIcon/ic_overall_program_default@2x.png")
        no-repeat;
      background-size: 24px 24px;
      transition: all 1s;
    }

    .top-icon {
      width: 24px;
      height: 24px;
      background: url("../static/newStatic/img/leftFixedIcon/ic_overall_top_default@2x.png")
        no-repeat;
      background-size: 24px 24px;
      transition: all 1s;
    }

    .weixin-box {
      // display: none;
      opacity: 1;
      width: 0;
      height: 0;
      padding: 0;
      position: absolute;
      right: 16px;
      top: -25px;
      // right: 76px;
      // top: 0px;
      // background: #ffffff;
      // box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px;

      img {
        position: absolute;
        right: 23px;
        top: 20px;
        width: 0;
        height: 0;
        transition: all 0.5s;
        z-index: 99999;
      }
      // transition: all 1s;
    }

    .top-box {
      // display: none;
      opacity: 1;
      width: 0;
      height: 0;
      padding: 0;
      position: absolute;
      right: 16px;
      top: -18px;
      // right: 76px;
      // top: 0px;
      // background: #ffffff;
      // box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px;

      img {
        position: absolute;
        right: 23px;
        top: 20px;
        width: 0;
        height: 0;
        transition: all 0.5s;
        z-index: 99999;
      }
      // transition: all 1s;
    }
  }

  .weixin-show:hover {
    color: #0046b9;
    cursor: pointer;

    .connect-icon {
      width: 24px;
      height: 24px;
      background: url("../static/newStatic/img/leftFixedIcon/ic_overall_connect_hover@2x.png")
        no-repeat;
      background-size: 24px 24px;
      transition: all 1s;
    }

    .weixin-icon {
      width: 24px;
      height: 24px;
      background: url("../static/newStatic/img/leftFixedIcon/ic_overall_wechat_hover@2x.png")
        no-repeat;
      background-size: 24px 24px;
      transition: all 1s;
    }

    .program-icon {
      width: 24px;
      height: 24px;
      background: url("../static/newStatic/img/leftFixedIcon/ic_overall_program_hover@2x.png")
        no-repeat;
      background-size: 24px 24px;
      transition: all 1s;
    }

    .top-icon {
      width: 24px;
      height: 24px;
      background: url("../static/newStatic/img/leftFixedIcon/ic_overall_top_hover@2x.png")
        no-repeat;
      background-size: 24px 24px;
      transition: all 1s;
    }
    .weixin-box {
      // display: block;
      opacity: 1;

      width: 314px;
      height: 136px;
      // padding: 16px;
      box-sizing: border-box;

      img {
        width: 314px;
        height: 136px;
        transition: all 1s;
      }
      transition: all 1s;
    }

    .top-box {
      // display: block;
      opacity: 1;

      width: 80px;
      height: 28px;
      // padding: 16px;
      box-sizing: border-box;

      img {
        width: 80px;
        height: 28px;
        transition: all 1s;
      }
      transition: all 1s;
    }

    .icon1 {
      opacity: 0;
      display: none;
      transition: all 1s;
    }

    .span-title-icon {
      opacity: 1;
      display: block;
      transition: all 1s;
    }
  }

  .top-box {
    position: relative;
    .icon1 {
      opacity: 1;
      @extend .first-icon;
      transition: all 1s;
    }

    .span-title-icon {
      opacity: 0;
      display: none;
      @extend .span-title;
      transition: all 1s;
    }
  }

  .top-box:hover {
    color: #0046b9;
    cursor: pointer;
    .icon1 {
      opacity: 0;
      display: none;
      // position: absolute;
      // top: 0;
      transition: all 1s;
    }

    .span-title-icon {
      opacity: 1;
      display: block;
      transition: all 1s;
    }
  }
}
.topClassShow {
  opacity: 1;
  width: 56px;
  height: 56px;
  transition: all 1s;
}

.topClassHide {
  opacity: 0;
  width: 0;
  height: 0;
  transition: all 1s;
}
.img-tip{
  position: absolute;
  //top: 0;
  margin:auto !important;
  width: 684px;
  height: 638px;
  left: 50%;
    right: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    /* display: grid; */
    /* place-items: center; */
    z-index: 9998;
}
.check-3{
      position: relative;
      width: 72px;
      height: 32px;
      top: 560px;
      left: 504px;
      //bottom: -24px;
}
.gray-777{
  color: #777777;
}
</style>



// WEBPACK FOOTER //
// src/App.vue